// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__GhqG7","checkbox":"Checkbox_checkbox__P4LNl"};